import { GetEventDivisionQuery } from "graphql/eventDivision.types";
import { EventDivisionModel } from "models/EventDivision";
import { createContext, useContext } from "react";

const EventDivisionContext = createContext<{
    eventDivision?: GetEventDivisionQuery["eventDivision"];
    eventDivisionObject?: EventDivisionModel | null;
}>({});
EventDivisionContext.displayName = "Event";

export const useEventDivision = () => useContext(EventDivisionContext).eventDivision;
export const useEventDivisionObject = () => useContext(EventDivisionContext).eventDivisionObject;
export const EventDivisionProvider = EventDivisionContext.Provider;
